"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The classnames() method returns the class names conditionally joining.
 *
 * @returns A String, representing the name of the generated class
 *
 * @author Aras Ekinci <dev@arasekinci.com>
 * @see classnames http://github.com/functions/classnames
 */
function classnames() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var classNames = [];
    for (var i = 0; i < args.length; i++) {
        var arg = args[i];
        if (arg) {
            if (typeof arg === 'string') {
                classNames.push(arg);
            }
            else if (typeof arg === 'object') {
                if (arg.toString === Object.prototype.toString) {
                    for (var key in arg) {
                        var value = arg[key];
                        if (Object.prototype.hasOwnProperty.call(arg, key) && value) {
                            if (typeof value === 'string') {
                                classNames.push(key + "-" + value);
                            }
                            else {
                                classNames.push(key);
                            }
                        }
                    }
                }
                else {
                    classNames.push(arg.toString());
                }
            }
        }
    }
    return classNames.join(' ');
}
exports.default = classnames;
